import api from '../../../services/api';

export const authService = {
  loginWithGoogle: (credential: string) =>
    api.post('/auth/google', { token: credential }),
};
